import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";

import Auth from "./Auth";

const PUBLIC_ROOT = "/login";

const AuthRoute = ({ component, ...props }) => {
  const isLoggedIn = Auth.isLoggedIn();

  if (isLoggedIn) {
    return <Route {...props} component={component} />;
  } else {
    return <Redirect to={PUBLIC_ROOT} />;
  }
};

AuthRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
};

export default AuthRoute;



// WEBPACK FOOTER //
// ./src/AuthRoute.js